import { Group, Popover, SelectProps, Text, UnstyledButton } from '@mantine/core';

import { useGetLanguageInfo } from '@/hooks/useGetLanguageInfo';
import { COUNTRY_FLAG_MAP, SvgArrow, SvgSelectCheck } from '@/components/SelectLanguage/icon';
import { useState } from 'react';

const renderSelectOption: SelectProps['renderOption'] = ({ checked, option }) => {
  const customOption = option as { label: string; value: string; desc: string };

  const getFlagEmoji = (countryCode: string) => {
    if (COUNTRY_FLAG_MAP[countryCode as keyof typeof COUNTRY_FLAG_MAP])
      return (
        <span style={{ width: '12px', display: 'inline-block' }}>
          {COUNTRY_FLAG_MAP[countryCode as keyof typeof COUNTRY_FLAG_MAP]()}
        </span>
      );
    return null;
  };

  return (
    <Group gap={8} className="w-full hover:bg-gray-100 p-1 my-1 rounded-md" justify="space-between" wrap="nowrap">
      <Group gap={5} wrap="nowrap">
        {getFlagEmoji(customOption.value)}
        <Text size="xs">{customOption.label}</Text>
      </Group>
      {checked && <SvgSelectCheck />}
    </Group>
  );
};

export const SelectLanguage = ({ isDigitalHuman, isWidget }: { isDigitalHuman?: boolean; isWidget?: boolean }) => {
  const [opened, setOpened] = useState<boolean>(false);
  const { langSelected, languageOnChange, languageOptions } = useGetLanguageInfo();

  const getFlagEmoji = (countryCode: string) => {
    if (COUNTRY_FLAG_MAP[countryCode as keyof typeof COUNTRY_FLAG_MAP])
      return COUNTRY_FLAG_MAP[countryCode as keyof typeof COUNTRY_FLAG_MAP]();
    return null;
  };

  return (
    <Popover opened={opened} onChange={setOpened} width={120} position="bottom" withArrow>
      <Popover.Target>
        <div
          className={`flex items-center justify-between cursor-pointer flex-none ${
            isDigitalHuman ? '' : 'border rounded-md sm:rounded-full px-2 py-1'
          }`}
          onClick={() => setOpened((o) => !o)}
        >
          <Group gap={5} wrap="nowrap" className="flex-1">
            <span style={{ width: '12px', display: 'inline-block' }}>{getFlagEmoji(langSelected?.value)}</span>
            <Text size="xs" c={isDigitalHuman || isWidget ? 'inherit' : 'gray.8'}>
              {langSelected?.label}
            </Text>
          </Group>
          <div
            className={`transition-transform duration-200 ${
              isDigitalHuman || isWidget ? 'text-inherit' : 'text-gray-8'
            }`}
            style={{ transform: opened ? 'rotate(180deg)' : 'rotate(0deg)' }}
          >
            <SvgArrow />
          </div>
        </div>
      </Popover.Target>

      <Popover.Dropdown className="p-2.5">
        {languageOptions.map((option) => (
          <UnstyledButton
            key={option.value}
            className="w-full"
            onClick={() => {
              languageOnChange(option.value);
              setOpened(false);
            }}
          >
            {renderSelectOption({ checked: option.value === langSelected?.value, option })}
          </UnstyledButton>
        ))}
      </Popover.Dropdown>
    </Popover>
  );
};
